namespace $.$$ {
	/**
	 * Toggle for Switcher between light/dark themes (usually for `mol_theme_auto` plugin).
	 * @see https://mol.hyoo.ru/#!section=demos/demo=mol_lights_demo
	 */
	export class $mol_lights_toggle extends $.$mol_lights_toggle {
		lights( next? : boolean ) {
			return this.$.$mol_lights( next )
		}
	}
}
